/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteComToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontakteCom);
    }

    return {};
}

